export default "__VITE_ASSET__99695795__"